import { Select } from "antd";
import { useListar } from "../../../../../../Services/Financeiro/Faturamento/Imposto/RegimeTributarioServices";
import { SelectComPesquisa } from "../../../../../SelectComPesquisa";
import RegimeTributario from "../../../../../../Models/Financeiro/Faturamento/Imposto/RegimeTributario";

interface IRegimeTributarioSelectProps extends Omit<React.ComponentProps<typeof Select>, "value" | "onChange" | "showSearch" | "optionFilterProp" | "filterOption"> {
    onChange?:(value:RegimeTributario|null) => void;
    value?:RegimeTributario|number;
}
export default function RegimeTributarioSelect({
    onChange,
    value,
    allowClear,
    ...props
}:IRegimeTributarioSelectProps) {
    const {
        data,
        isLoading
    } = useListar({
        ativo : true
    });

    return <SelectComPesquisa 
        {...props}
        placeholder={"Todos"}
        allowClear={allowClear ?? true}
        loading={isLoading}
        onChange={(value) => {
            onChange?.(value == null ? null : (data?.find(f => f.codigo == value) ?? null));
        }}
        value={typeof value === "number" ? value : value?.codigo}
        options={data?.map(m => {
            return {
                value : m.codigo,
                label : m.nome
            }
        })}
    />
}